module.exports = {
      id: "bullet-arrow-usage",
      viewBox: "0 0 22 20",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#bullet-arrow",
      toString: function () {
        return this.url;
      }
    }